import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';

export const useReasonerParams = () => {
  const { params, setQueryParams, deleteQueryParam } = useQueryParams();

  const setReasonerParams = (params: {
    conversationId?: string;
    mode?: string;
  }) => {
    setQueryParams({
      [queryKeys.conversationId]: params.conversationId,
      [queryKeys.mode]: 'research',
    });
  };

  return {
    conversationId: params.conversationId ?? '',
    mode: params.mode,
    setReasonerParams,
    deleteReasonerConversationId: () =>
      deleteQueryParam(queryKeys.conversationId),
  };
};
